<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <div class="search-pg animals-pg plants-pg">
      <h1 class="title-pg-default">{{ $t('База данных растительного мира Кыргызстана') }}</h1>
      <SearchForm
        :retSearch="true"
        :totalCount="paginationData.totalCount"
        @searchFlora="searchFlora($event, true)"
      />
      <div class="search-body bgw-pdg-20">
        <div class="type-column">
          <div class="table-overflow">
            <table class="table-full">
              <thead>
                <tr>
                  <td class="td-name">
                    <div class="sort-flex">
                      {{ $t('Вид') }}
                      <a @click="sort('name')" class="sort-btn sort-blue">
                        <v-icon v-if="sortParams.field == 'name' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                        <v-icon v-else>arrow_drop_down</v-icon>
                      </a>
                    </div>
                  </td>
                  <td class="td-status">
                    <div class="sort-flex">
                      {{ $t('Статус') }}
                      <a @click="sort('nationalStatus')" class="sort-btn sort-blue">
                        <v-icon v-if="sortParams.field == 'nationalStatus' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                        <v-icon v-else>arrow_drop_down</v-icon>
                      </a>
                    </div>
                  </td>
                  <td class="td-kind">
                    <div class="sort-flex">
                      {{ $t('Род') }}
                      <a @click="sort('floraFamily')" class="sort-btn sort-blue">
                        <v-icon v-if="sortParams.field == 'floraFamily' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                        <v-icon v-else>arrow_drop_down</v-icon>
                      </a>
                    </div>
                  </td>
                  <td class="td-squad">
                    <div class="sort-flex">
                      {{ $t('Семейство') }}
                      <a @click="sort('floraSquad')" class="sort-btn sort-blue">
                        <v-icon v-if="sortParams.field == 'floraSquad' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                        <v-icon v-else>arrow_drop_down</v-icon>
                      </a>
                    </div>
                  </td>
                  <td class="td-class">
                    <div class="sort-flex">
                      {{ $t('Класс') }}
                      <a @click="sort('floraClass')" class="sort-btn sort-blue">
                        <v-icon v-if="sortParams.field == 'floraClass' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                        <v-icon v-else>arrow_drop_down</v-icon>
                      </a>
                    </div>
                  </td>
                  <td class="td-control">
                    <div class="sort-flex">
                      {{ $t('Отдел') }}
                      <a @click="sort('isControlled')" class="sort-btn sort-blue">
                        <v-icon v-if="sortParams.field == 'isControlled' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                        <v-icon v-else>arrow_drop_down</v-icon>
                      </a>
                    </div>
                  </td>
                  <td class="td-control">
                    <div class="sort-flex">
                      {{ $t('Красная книга КР') }}
                      <a @click="sort('redBook')" class="sort-btn sort-blue">
                        <v-icon v-if="sortParams.field == 'redBook' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                        <v-icon v-else>arrow_drop_down</v-icon>
                      </a>
                    </div>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in result"
                  :key="item.id"
                >
                  <td class="td-name">
                    <router-link :to="{ name: 'flora-view', params: { id: item.id }}">{{ item.name }}</router-link>
                  </td>
                  <td class="td-status">{{ item.nationalStatus }}</td>
                  <td class="td-kind">{{ item.floraGenus }}</td>
                  <td class="td-squad">{{ item.floraFamily }}</td>
                  <td class="td-class">{{ item.floraClass }}</td>
                  <td class="td-control">{{ item.floraBranch }}</td>
                  <td class="td-control">
                    <v-icon v-if="item.redBook">check</v-icon>
                  </td>
                </tr>
              </tbody>
            </table>
            <v-pagination
              v-model="page"
              :length="paginationData.pageCount"
              total-visible="10"
            />
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import Flora from '@/model/flora'
import { mapMutations } from 'vuex'
import SearchForm from '@/components/flora/SearchForm'

export default {
  components: { SearchForm },
  data: () => ({
    search: {},
    breadcrumbs: [],
    baseUrl: process.env.VUE_APP_BACK_URL,
    page: 1,
    paginationData: {},
    data: [],
    result: [],
    sortParams: {
      field: 'name',
      order: 'ASC'
    }
  }),
  watch: {
    // при изменениях маршрута запрашиваем данные снова
    $route: 'fetchData',
    page () {
      this.searchFlora(this.search)
    }
  },
  created () {
    // загружаем данные, когда представление создано
    // и данные реактивно отслеживаются
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.search = this.$route.query

      Flora.getFloraData().then((response) => {
        this.data = response.data

        this.breadcrumbs = [
          { text: this.$i18n.t('Главная'), disabled: false, href: '/' },
          { text: this.$i18n.t('База данных растительного мира КР'), disabled: true }
        ]
        this.setLoading(false)
        this.searchFlora(this.search)
      })
    },
    searchFlora (search, resetPage = false) {
      this.setLoading(true)
      this.search = search
      if (resetPage) {
        this.page = 1
      }
      this.search.page = this.page
      this.search.sortField = this.sortParams.field
      this.search.sortOrder = this.sortParams.order

      Flora.list(this.search).then((response) => {
        this.result = response.data.items
        this.paginationData = response.data.paginationData
        this.setLoading(false)
      })
    },
    sort (field) {
      this.page = 1
      this.sortParams.field = field
      this.sortParams.order = this.sortParams.order === 'ASC' ? 'DESC' : 'ASC'

      this.searchFlora(this.search, true)
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>
